import * as z from "zod";

import { SupportOrderFlowType } from "~/graphql/graphql.gen";
import { searchOrdersQueryParamsSchema } from "~/validators/search-orders-validator";

export const createGroupActionQueryParamsSchema = z.object({
  ...searchOrdersQueryParamsSchema.shape,
  reason: z.enum(SupportOrderFlowType).optional(),
});

export type CreateGroupActionQueryParams = z.infer<
  typeof createGroupActionQueryParamsSchema
>;
